var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom_btn_container bgwhite1",class:{ disabled: _vm.disabled, fixed: _vm.fixed, cancel: _vm.cancel }},[_c('div',{staticClass:"btn"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }